"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var _CheckGoodUsageErrorTypes = _interopRequireDefault(require("../constants/CheckGoodUsageErrorTypes"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _GoodsActions = require("../actions/GoodsActions");

var showNotification = function showNotification(notification) {
  return {
    type: _ActionTypes.default.SHOW_APP_NOTIFICATION,
    meta: {
      notification: notification
    }
  };
};

var removeNotification = function removeNotification(id) {
  return {
    type: _ActionTypes.default.REMOVE_APP_NOTIFICATION,
    meta: {
      removeNotification: {
        id: id
      }
    }
  };
};

var _default = function _default(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      var prevState = getState();
      var result = next(action);

      switch (action.type) {
        case _ActionTypes.default.CHECK_GOOD_USAGE:
          {
            if (action.error) {
              var _action$payload = action.payload,
                  errorId = _action$payload.errorId,
                  errorType = _action$payload.errorType,
                  good = _action$payload.good;
              var isForUninstall = errorType === _CheckGoodUsageErrorTypes.default.ATTEMPTED_UNINSTALL;
              var titleTextKey;

              if (good && good.get('subType') === _GoodSubTypes.default.CUSTOM_MODULE) {
                titleTextKey = isForUninstall ? 'errorCheckingModuleUsageForUninstall' : 'errorCheckingModuleUsage';
              } else {
                titleTextKey = isForUninstall ? 'errorCheckingTemplateUsageForUninstall' : 'errorCheckingTemplateUsage';
              }

              dispatch(showNotification({
                id: errorId,
                type: 'danger',
                titleText: (0, _unescapedText.default)("managePurchases." + titleTextKey + ".titleText"),
                closeable: true,
                onClose: function onClose() {
                  return dispatch((0, _GoodsActions.closeCheckGoodUsageErrorAlert)(errorId));
                }
              }));
            }

            break;
          }

        case _ActionTypes.default.CHECK_GOOD_USAGE_ERROR_ALERT_DISMISSED:
          {
            var _errorId2 = action.payload.errorId;

            if (_errorId2) {
              dispatch(removeNotification(_errorId2));
            } else {
              var errorIds = prevState.managePurchases.get('checkGoodUsageErrorIds').keySeq();
              errorIds.forEach(function (_errorId) {
                return dispatch(removeNotification(_errorId));
              });
            }

            break;
          }

        default:
          break;
      }

      return result;
    };
  };
};

exports.default = _default;
module.exports = exports.default;